type RoomOrderFields = {
  name: string;
  floor_sort: number;
  sort_order: number;
};

function hasMeaningfulGlobalOrder(rooms: RoomOrderFields[]): boolean {
  if (rooms.length < 2) return true;
  const orders = rooms.map((room) => room.sort_order);
  return orders.every((order) => Number.isInteger(order) && order >= 0)
    && new Set(orders).size === orders.length;
}

export function sortRoomsForDisplay<T extends RoomOrderFields>(rooms: T[]): T[] {
  const globallyOrdered = hasMeaningfulGlobalOrder(rooms);
  return [...rooms].sort((left, right) => {
    if (globallyOrdered) {
      return left.sort_order - right.sort_order || left.name.localeCompare(right.name);
    }
    return right.floor_sort - left.floor_sort
      || left.sort_order - right.sort_order
      || left.name.localeCompare(right.name);
  });
}
